import { Box, Breakpoint, ZIndex } from "@gocardless/flux-react";
import { useUserShowSelf } from "@gocardless/api/dashboard/user";

import { ExportsCentreConnect } from "./ExportCentreConnect";

import { useIsBreakpoint } from "src/hooks/useIsBreakpoint";

export const ExportCentreContainer: React.FC = () => {
  const { data: user } = useUserShowSelf();
  const isMobileBreakpoint = useIsBreakpoint({ max: Breakpoint.Md });
  const userId = user?.users?.id;
  if (!userId) return <></>;

  return (
    <Box
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        ...(isMobileBreakpoint && { left: "10px", right: "10px" }),
        zIndex: ZIndex.Dialog,
      }}
    >
      <ExportsCentreConnect />
    </Box>
  );
};
